import { FormattedMessage } from 'react-intl';

export const CampaignBanner = () => {
  return (
    <div className="campaign-banner">
      <div className="campaign-banner__content">
        <h2 className="campaign-banner__title">
          <FormattedMessage id="CAMPAIGN_BANNER.TITLE" />
        </h2>
        <p className="campaign-banner__text">
          {/* One message with tags rather than three keys glued together: the lead,
              the discount and the deadline are one sentence, and a translator needs
              to move them around each other. French puts the "20 %" badge in a
              different place in the phrase than German does, which splitting into
              fragments would make impossible. */}
          <FormattedMessage
            id="CAMPAIGN_BANNER.TEXT"
            values={{
              lead: (chunks) => <span className="campaign-banner__lead">{chunks}</span>,
              badge: (chunks) => <span className="campaign-banner__badge">{chunks}</span>,
              note: (chunks) => <span className="campaign-banner__note">{chunks}</span>,
            }}
          />
        </p>
      </div>
      <img
        src="/media/img/misc/wdd-banner-img.webp"
        alt="Campaign img"
        className="campaign-banner__image"
      />
    </div>
  );
};
